import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import { AreaCategoria } from "../models/Maestras/maestras.model";

export const useGestionAreasCategorias = () => {
    const [cantidadpaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };


    const [areasCategorias, setAreasCategorias] = useState<AreaCategoria[]>([]);
    const obtenerAreasCategorias = async() => {
        try {
            const areasCategorias = await apiMaestras.obtenerAreasCategorias();
            setAreasCategorias(areasCategorias)
        } catch (error) {
            console.log(error);
        }
    }

    return {
        cantidadpaginas,
        cambiarCantidadPaginas,
        obtenerAreasCategorias,
        areasCategorias
    } 
}
